import { GET_COUNTRYCODE, GET_LOGIN, GET_OTP, POST_LOGOUT } from "../../resources/actionTypes";

const initialState = {
  userLogin: [],
  loading: false,
  error: null,
};

const logoutInitialState = {
  loading: false,
  error: null,
};

const initialStateCountryCode = {
  countryCodeList: [],
  loading: false,
  error: null,
};

export const auth = (state = initialState, action) => {
  switch (action.type) {
    case GET_LOGIN.GET_LOGIN_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_LOGIN.GET_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        userLogin: action.userLogin,
      };
    case GET_LOGIN.GET_LOGIN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case GET_OTP.GET_OTP_REQUESTED:
      return {
        ...state,
        loading: true,
        isAuth: false,
      };
    case GET_OTP.GET_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuth: true,
        userOtp: action.userOtp,
      };
    case GET_OTP.GET_OTP_FAILED:
      return {
        ...state,
        loading: false,
        isAuth: false,
        error: action.message,
      };

    default:
      return state;
  }
};

export function postLogout(state = logoutInitialState, action) {
  switch (action.type) {
    case POST_LOGOUT.POST_LOGOUT_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case POST_LOGOUT.POST_LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case POST_LOGOUT.POST_LOGOUT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function getCountryCode(state = initialStateCountryCode, action) {
  switch (action.type) {
    case GET_COUNTRYCODE.GET_COUNTRYCODE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COUNTRYCODE.GET_COUNTRYCODE_SUCCESS:
      return {
        ...state,
        loading: false,
        countryCodeList: action.countryCodeList
      };
    case GET_COUNTRYCODE.GET_COUNTRYCODE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}